import React from 'react';
import { Portal, PortalAsync } from '@edreamsodigeo/frontend-core';
import { WaitingPaxPrimeMessage, WaitingIntermediatePrimeMessage, HeaderPrimeButton, WaitingPageLabelMeta, RefundableFlightsBanner } from '@edreamsodigeo/frontend-prime';
import { AlternativeFlightModal } from '@edreamsodigeo/frontend-flights-results';
import { DetailsLoadingTranslationsPageProvider } from './TranslationsPageProvider';
import PrimeResultsProvider from '../../../funnels/FlightResults/providers/PrimeResultsProvider';
const AlternativeFlightModalWrapper = () => /*#__PURE__*/React.createElement(PrimeResultsProvider, null, /*#__PURE__*/React.createElement(AlternativeFlightModal, null));
const DetailsLoadingPage = () => /*#__PURE__*/React.createElement(DetailsLoadingTranslationsPageProvider, null, /*#__PURE__*/React.createElement(Portal, {
  elementId: 'header_prime_button_container_funnel',
  Component: HeaderPrimeButton
}), /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "waiting_passengers_prime_container",
  parentId: "waiting-pages",
  Component: WaitingPaxPrimeMessage
}), /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "waiting_passengers_prime_banner_container",
  parentId: "waiting-pages",
  Component: RefundableFlightsBanner
}), /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "waiting_intermediate_prime_container",
  parentId: "waiting-page",
  Component: WaitingIntermediatePrimeMessage
}), /*#__PURE__*/React.createElement(Portal, {
  elementId: "waiting_page_label_meta_container",
  Component: WaitingPageLabelMeta
}), /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "alternative_flight_modal_detailsloading_container",
  parentId: "alternative_flight_modal_detailsloading_wrapper",
  Component: AlternativeFlightModalWrapper
}), /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "alternative_flight_modal_xsellproductselection_container",
  parentId: "alternative_flight_modal_xsellproductselection_wrapper",
  Component: AlternativeFlightModal
}));
export default DetailsLoadingPage;